import * as Phaser from "phaser-ce"
import { CCUtils } from "../../../../common/CCUtils"

export enum ShortTermAssets {
    BABY = "ShortTermBABY",
    KID = "ShortTermKID",
    MOTHER = "ShortTermMOTHER",
    FATHERS_SMOKE = "ShortTermFATHERS_SMOKE",

    BACKGROUND = "ShortTermBACKGROUND",
    FATHER = "ShortTermFATHER",

    INTRO = "ShortTermINTRO",
    CLICK_BABY = "ShortTermCLICK_BABY",
    CLICK_TEEN = "ShortTermCLICK_TEEN",
    BABY_CRYING = "ShortTermBABY_CRYING",
    KID_COUGHING = "ShortTermKID_COUGHING",
    MOTHER_COUGHING = "ShortTermMOTHER_COUGHING",
}

export function loadAssets(game: Phaser.Game) {
    game.load.spritesheet(ShortTermAssets.BABY, CCUtils.asset("second-hand/short-term/baby.png"), 192, 225)
    game.load.spritesheet(ShortTermAssets.KID, CCUtils.asset("second-hand/short-term/kid.png"), 173, 226)
    game.load.spritesheet(ShortTermAssets.MOTHER, CCUtils.asset("second-hand/short-term/mother.png"), 196, 323)
    game.load.spritesheet(ShortTermAssets.FATHERS_SMOKE, CCUtils.asset("second-hand/short-term/fathers-smoke.png"), 11, 57)

    game.load.image(ShortTermAssets.BACKGROUND, CCUtils.asset("second-hand/long-term/rat-table.png"))
    game.load.image(ShortTermAssets.FATHER, CCUtils.asset("second-hand/short-term/father-no-smoke.png"))

    game.load.audio(ShortTermAssets.INTRO, CCUtils.asset("second-hand/short-term/audio/1-click-on-woman.mp3"))
    game.load.audio(ShortTermAssets.CLICK_BABY, CCUtils.asset("second-hand/short-term/audio/2-click-on-baby.mp3"))
    game.load.audio(ShortTermAssets.CLICK_TEEN, CCUtils.asset("second-hand/short-term/audio/3-click-on-teen.mp3"))
    game.load.audio(ShortTermAssets.BABY_CRYING, CCUtils.asset("second-hand/short-term/audio/baby-crying.wav"))
    game.load.audio(ShortTermAssets.KID_COUGHING, CCUtils.asset("second-hand/short-term/audio/kid-coughing.wav"))
    game.load.audio(ShortTermAssets.MOTHER_COUGHING, CCUtils.asset("second-hand/short-term/audio/woman-coughing.mp3"))
}
